import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
const CheckinCardItem = ({ className, children, delimiter, delimiterText, delimiterGap, spacingBottom, padding, classes }) => {
    const { CheckinCardItem: theme } = useTheme('CheckinCardItem');
    const [calculatedFontSize, setCalculatedFontSize] = React.useState(null);
    const delimiterTextRef = React.useRef(null);
    React.useEffect(() => {
        if (delimiterTextRef.current) {
            const textHeight = delimiterTextRef.current.offsetHeight;
            const halfTextHeight = Math.ceil(textHeight / 2);
            setCalculatedFontSize(halfTextHeight);
        }
    }, [delimiterText]);
    return (React.createElement("div", { className: cn(theme.container, className), style: { padding, marginBottom: spacingBottom } },
        React.createElement("div", { className: cn(theme.content, classes === null || classes === void 0 ? void 0 : classes.content) }, children),
        delimiter && (React.createElement("div", { className: cn(theme.delimiter, theme[delimiter], {
                [theme.delimiterGap]: delimiterText || delimiterGap
            }), style: calculatedFontSize && {
                marginTop: `${calculatedFontSize}px`,
                marginBottom: `${calculatedFontSize}px`
            } }, delimiterText && (React.createElement("div", { ref: delimiterTextRef, className: theme.delimiterText }, delimiterText))))));
};
export default CheckinCardItem;
